
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { Hierarchy_getPath } from "../../Shared/Location.js";
import { ofArray, contains, tryFind, filter, map } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { DtoType__get_IsSelfService, DtoType__get_Description, DtoType__get_Name, DtoType__get_AccessByUser, DtoType__get_AssignedUserIds, DtoType__get_BusinessUnitId, Msg, DtoType__get_LocationId } from "./Types.js";
import { FormState__getValidation, LocationId__get_unwrap } from "../../Shared/Shared.js";
import { unwrap, map as map_1 } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { MultiSelect, Select } from "../../Components/Select.js";
import { createObj, stringHash } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { isSystemAccount } from "../../UserPermissions.js";
import { FormContainer } from "../../Components/FormContainer.js";
import { empty, singleton, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { Input } from "../../Components/Input.js";
import { Feature, isFeatureEnabled } from "../../FeatureFlip.js";
import { InformationAlert, WarningAlert } from "../../Components/Alert.js";
import { Checkbox } from "../../Components/Checkbox.js";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { initEditStorageView, update as update_1, initNewStorageView } from "./State.js";
import { reactElement, reactApi } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { withoutOnboardingTourQueryParams, isManageStoragesTourFormPhase } from "../../Common.js";
import { RouterModule_encodeQueryString, RouterModule_nav } from "../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { join } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { TourGuideLocale, TourStep, TourGuide } from "../../Components/TourGuide.js";
import { Skeleton } from "../../Components/Skeleton.js";

function LocationProps(props) {
    const t = useTranslation()[0];
    const componentState = props.FormState.IsLoading ? "disabled" : "enabled";
    const mapLocation = (location) => ({
        label: Hierarchy_getPath(props.Locations, location),
        value: location,
    });
    const options = map(mapLocation, filter((location_1) => {
        const matchValue = DtoType__get_LocationId(props.Dto);
        if (matchValue == null) {
            return true;
        }
        else {
            const locationId = matchValue;
            return LocationId__get_unwrap(location_1.Id) !== locationId;
        }
    }, props.Locations));
    let selectedLocation;
    const matchValue_1 = DtoType__get_LocationId(props.Dto);
    if (matchValue_1 == null) {
        selectedLocation = undefined;
    }
    else {
        const locationId_1 = matchValue_1;
        selectedLocation = map_1(mapLocation, tryFind((location_2) => (LocationId__get_unwrap(location_2.Id) === locationId_1), props.Locations));
    }
    return createElement(Select, {
        ComponentState: componentState,
        IsClearable: true,
        Label: t("general.location"),
        NoOptionsMessage: "select.location_no_options",
        OnChange: (arg) => {
            props.Dispatch(new Msg(3, [arg]));
        },
        Options: options,
        PlaceholderKey: "select.location_placeholder",
        TestId: "storage-form-location",
        ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "location")),
        Value: unwrap(selectedLocation),
    });
}

function BusinessUnitSelect(props) {
    const t = useTranslation()[0];
    const componentState = props.FormState.IsLoading ? "disabled" : "enabled";
    const mapBusinessUnit = (businessUnit) => ({
        label: businessUnit.Name,
        value: businessUnit,
    });
    const options = map(mapBusinessUnit, filter((businessUnit_1) => {
        const matchValue = DtoType__get_BusinessUnitId(props.Dto);
        if (matchValue == null) {
            return true;
        }
        else {
            return businessUnit_1.Id !== matchValue;
        }
    }, props.BusinessUnits));
    let selectedBusinessUnit;
    const matchValue_1 = DtoType__get_BusinessUnitId(props.Dto);
    if (matchValue_1 == null) {
        selectedBusinessUnit = undefined;
    }
    else {
        const businessUnitId_1 = matchValue_1;
        selectedBusinessUnit = map_1(mapBusinessUnit, tryFind((businessUnit_2) => (businessUnit_2.Id === businessUnitId_1), props.BusinessUnits));
    }
    return createElement(Select, {
        ComponentState: componentState,
        IsClearable: true,
        Label: t("business_units.business_unit"),
        NoOptionsMessage: "business_units.select.no_options",
        OnChange: (arg) => {
            props.Dispatch(new Msg(4, [arg]));
        },
        Options: options,
        PlaceholderKey: "business_units.select.placeholder",
        TestId: "storage-business-unit-select",
        ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "business_unit")),
        Value: unwrap(selectedBusinessUnit),
    });
}

function AssignedUserSelect(props) {
    const t = useTranslation()[0];
    const componentState = props.FormState.IsLoading ? "disabled" : "enabled";
    const mapUser = (user) => ({
        label: user.Name,
        value: user,
    });
    const selectedUsers = map(mapUser, filter((u_1) => contains(u_1.Id, DtoType__get_AssignedUserIds(props.Dto), {
        Equals: (x_1, y_1) => (x_1 === y_1),
        GetHashCode: (x_1) => (stringHash(x_1) | 0),
    }), props.Users));
    return createElement(MultiSelect, {
        ComponentState: componentState,
        IsClearable: false,
        Label: t("general.stockist"),
        NoOptionsMessage: "select.tool_manager_no_options",
        OnChange: (arg) => {
            props.Dispatch(new Msg(5, [arg]));
        },
        Options: map(mapUser, filter((u) => {
            if (!contains(u.Id, DtoType__get_AssignedUserIds(props.Dto), {
                Equals: (x, y) => (x === y),
                GetHashCode: (x) => (stringHash(x) | 0),
            })) {
                return !isSystemAccount(u);
            }
            else {
                return false;
            }
        }, props.Users)),
        PlaceholderKey: "select.tool_manager_placeholder",
        TestId: "storage-form-stockist",
        ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "assigned_user")),
        Value: selectedUsers,
    });
}

function AccessUserSelect(props) {
    const t = useTranslation()[0];
    const componentState = props.FormState.IsLoading ? "disabled" : "enabled";
    const mapUser = (user) => ({
        label: user.Name,
        value: user,
    });
    const selectedUsers = map(mapUser, filter((u_1) => contains(u_1.Id, DtoType__get_AccessByUser(props.Dto), {
        Equals: (x_1, y_1) => (x_1 === y_1),
        GetHashCode: (x_1) => (stringHash(x_1) | 0),
    }), props.Users));
    return createElement(MultiSelect, {
        ComponentState: componentState,
        IsClearable: false,
        Label: t("storage.self_service_user"),
        NoOptionsMessage: "select.employee_no_options",
        OnChange: (arg) => {
            props.Dispatch(new Msg(6, [arg]));
        },
        Options: map(mapUser, filter((u) => !contains(u.Id, DtoType__get_AccessByUser(props.Dto), {
            Equals: (x, y) => (x === y),
            GetHashCode: (x) => (stringHash(x) | 0),
        }), props.Users)),
        PlaceholderKey: "select.self_service_user_placeholder",
        TestId: "storage-self-service-users-select",
        ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "access_user")),
        Value: selectedUsers,
    });
}

export function StorageForm(props) {
    const t = useTranslation()[0];
    const componentState = props.FormState.IsLoading ? "disabled" : "enabled";
    return createElement(FormContainer, {
        Children: toList(delay(() => {
            let Label, Value;
            return append(singleton(createElement(Input, (Label = t("general.name"), (Value = DtoType__get_Name(props.Dto), {
                ComponentState: componentState,
                Label: unwrap(Label),
                OnChange: (arg) => {
                    props.Dispatch(new Msg(0, [arg]));
                },
                TestId: "storage-form-name",
                ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "name")),
                Value: Value,
            })))), delay(() => append(singleton(createElement(Input, {
                ComponentState: componentState,
                Label: t("general.description"),
                OnChange: (arg_1) => {
                    props.Dispatch(new Msg(1, [arg_1]));
                },
                TestId: "storage-form-description",
                Value: DtoType__get_Description(props.Dto),
            })), delay(() => append(isFeatureEnabled(new Feature(17, [])) ? (props.AccountSettings.BusinessUnitsEnabled ? singleton(createElement(BusinessUnitSelect, {
                BusinessUnits: props.BusinessUnits,
                Dispatch: props.Dispatch,
                Dto: props.Dto,
                FormState: props.FormState,
            })) : empty()) : empty(), delay(() => append(singleton(createElement(LocationProps, {
                Dispatch: props.Dispatch,
                Dto: props.Dto,
                FormState: props.FormState,
                Locations: props.Locations,
            })), delay(() => append(singleton(createElement(AssignedUserSelect, {
                Dispatch: props.Dispatch,
                Dto: props.Dto,
                FormState: props.FormState,
                Users: props.Users,
            })), delay(() => (props.CustomerConfiguration.GlobalSelfServiceStorageActive ? singleton(createElement(WarningAlert, {
                Label: "storage.self_service_is_configured_global",
            })) : append(singleton(Checkbox({
                ComponentState: componentState,
                IsChecked: DtoType__get_IsSelfService(props.Dto),
                Label: t("storage.is_self_service_active"),
                OnCheck: (arg_2) => {
                    props.Dispatch(new Msg(2, [arg_2]));
                },
                TestId: "storage-is-self-service-active-checkbox",
            })), delay(() => append(singleton(createElement(InformationAlert, {
                Label: t("storage.is_self_service_active_info"),
            })), delay(() => (!DtoType__get_IsSelfService(props.Dto) ? singleton(createElement(AccessUserSelect, {
                Dispatch: props.Dispatch,
                Dto: props.Dto,
                FormState: props.FormState,
                Users: props.Users,
            })) : empty()))))))))))))))));
        })),
        FormState: props.FormState,
        Header: props.Header,
        OnBack: props.OnBack,
        OnSave: props.OnSave,
    });
}

export function StorageNewView() {
    let elems;
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(initNewStorageView, update_1, (_arg, _arg_1) => {
    }), undefined, undefined);
    const state_1 = patternInput[0];
    const dispatch = patternInput[1];
    const t = useTranslation()[0];
    const patternInput_2 = reactApi.useState(false);
    const setManageStoragesFormTourDismissed = patternInput_2[1];
    const showManageStoragesFormTour = isManageStoragesTourFormPhase() && !patternInput_2[0];
    const clearManageStoragesTourFromUrl = () => {
        RouterModule_nav(ofArray(["storages", "new" + RouterModule_encodeQueryString(withoutOnboardingTourQueryParams())]), 1, 1);
    };
    const matchValue = state_1.Locations;
    const matchValue_1 = state_1.Users;
    const matchValue_2 = state_1.Configuration;
    const matchValue_3 = state_1.AccountSettings;
    const matchValue_4 = state_1.BusinessUnits;
    let matchResult, accountSettings, businessUnits, configuration, locations, users;
    if (matchValue.tag === 0) {
        if (matchValue_4.tag === 0) {
            matchResult = 1;
        }
        else if (matchValue_3.tag === 0) {
            matchResult = 1;
        }
        else if (matchValue_2.tag === 0) {
            matchResult = 1;
        }
        else if (matchValue_1.tag === 0) {
            matchResult = 1;
        }
        else {
            matchResult = 1;
        }
    }
    else if (matchValue_1.tag === 0) {
        if (matchValue_4.tag === 0) {
            matchResult = 1;
        }
        else if (matchValue_3.tag === 0) {
            matchResult = 1;
        }
        else if (matchValue_2.tag === 0) {
            matchResult = 1;
        }
        else {
            matchResult = 1;
        }
    }
    else if (matchValue_2.tag === 0) {
        if (matchValue_4.tag === 0) {
            matchResult = 1;
        }
        else if (matchValue_3.tag === 0) {
            matchResult = 1;
        }
        else {
            matchResult = 1;
        }
    }
    else if (matchValue_3.tag === 0) {
        if (matchValue_4.tag === 0) {
            matchResult = 1;
        }
        else {
            matchResult = 1;
        }
    }
    else if (matchValue_4.tag === 0) {
        matchResult = 1;
    }
    else {
        matchResult = 0;
        accountSettings = matchValue_3.fields[0];
        businessUnits = matchValue_4.fields[0];
        configuration = matchValue_2.fields[0];
        locations = matchValue.fields[0];
        users = matchValue_1.fields[0];
    }
    switch (matchResult) {
        case 0:
            return reactElement("div", createObj(ofArray([["className", join(" ", ["h-full", "flex", "flex-col"])], (elems = toList(delay(() => append(singleton(createElement(StorageForm, {
                AccountSettings: accountSettings,
                BusinessUnits: businessUnits,
                CustomerConfiguration: configuration,
                Dispatch: dispatch,
                Dto: state_1.Dto,
                FormState: state_1.FormState,
                Header: t("storage.create_new_storage"),
                Locations: locations,
                OnBack: () => {
                    RouterModule_nav(ofArray(["storages"]), 1, 1);
                },
                OnSave: () => {
                    dispatch(new Msg(7, []));
                },
                Users: users,
            })), delay(() => {
                let Steps;
                return showManageStoragesFormTour ? singleton(createElement(TourGuide, (Steps = ofArray([new TourStep("[data-test-id=\'storage-form-name\']", t("onboarding.tour.storage_form_name_title"), reactElement("div", {
                    children: t("onboarding.tour.storage_form_name_content"),
                }), "bottom", true), new TourStep("[data-test-id=\'storage-form-location\']", t("onboarding.tour.storage_form_location_title"), reactElement("div", {
                    children: t("onboarding.tour.storage_form_location_content"),
                }), "bottom", true), new TourStep("[data-test-id=\'storage-form-stockist\']", t("onboarding.tour.storage_form_stockist_title"), reactElement("div", {
                    children: t("onboarding.tour.storage_form_stockist_content"),
                }), "bottom", true)]), {
                    IsRunning: true,
                    Locale: new TourGuideLocale(t("onboarding.tour.joyride_back"), t("onboarding.tour.joyride_close"), t("onboarding.tour.joyride_last"), t("onboarding.tour.joyride_next"), t("onboarding.tour.joyride_next_with_progress"), t("onboarding.tour.joyride_open"), t("onboarding.tour.joyride_skip")),
                    OnFinish: () => {
                        setManageStoragesFormTourDismissed(true);
                        clearManageStoragesTourFromUrl();
                    },
                    OnSkip: () => {
                        setManageStoragesFormTourDismissed(true);
                        clearManageStoragesTourFromUrl();
                    },
                    ScrollFirstStep: true,
                    Steps: Steps,
                }))) : empty();
            })))), ["children", reactApi.Children.toArray(Array.from(elems))])])));
        default:
            return createElement(Skeleton, {
                Variant: "detail",
            });
    }
}

export function StorageEditView(props) {
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(initEditStorageView, update_1, (_arg, _arg_1) => {
    }), props.StorageId, undefined);
    const state_1 = patternInput[0];
    const dispatch = patternInput[1];
    const patternInput_1 = useTranslation();
    const matchValue = state_1.Storage;
    const matchValue_1 = state_1.Locations;
    const matchValue_2 = state_1.Users;
    const matchValue_3 = state_1.Configuration;
    const matchValue_4 = state_1.AccountSettings;
    const matchValue_5 = state_1.BusinessUnits;
    let matchResult, accountSettings, businessUnits, configuration, locations, storage, users;
    if (matchValue.tag === 0) {
        if (matchValue_5.tag === 0) {
            matchResult = 1;
        }
        else if (matchValue_4.tag === 0) {
            matchResult = 1;
        }
        else if (matchValue_3.tag === 0) {
            matchResult = 1;
        }
        else if (matchValue_2.tag === 0) {
            matchResult = 1;
        }
        else if (matchValue_1.tag === 0) {
            matchResult = 1;
        }
        else {
            matchResult = 1;
        }
    }
    else if (matchValue_1.tag === 0) {
        if (matchValue_5.tag === 0) {
            matchResult = 1;
        }
        else if (matchValue_4.tag === 0) {
            matchResult = 1;
        }
        else if (matchValue_3.tag === 0) {
            matchResult = 1;
        }
        else if (matchValue_2.tag === 0) {
            matchResult = 1;
        }
        else {
            matchResult = 1;
        }
    }
    else if (matchValue_2.tag === 0) {
        if (matchValue_5.tag === 0) {
            matchResult = 1;
        }
        else if (matchValue_4.tag === 0) {
            matchResult = 1;
        }
        else if (matchValue_3.tag === 0) {
            matchResult = 1;
        }
        else {
            matchResult = 1;
        }
    }
    else if (matchValue_3.tag === 0) {
        if (matchValue_5.tag === 0) {
            matchResult = 1;
        }
        else if (matchValue_4.tag === 0) {
            matchResult = 1;
        }
        else {
            matchResult = 1;
        }
    }
    else if (matchValue_4.tag === 0) {
        if (matchValue_5.tag === 0) {
            matchResult = 1;
        }
        else {
            matchResult = 1;
        }
    }
    else if (matchValue_5.tag === 0) {
        matchResult = 1;
    }
    else {
        matchResult = 0;
        accountSettings = matchValue_4.fields[0];
        businessUnits = matchValue_5.fields[0];
        configuration = matchValue_3.fields[0];
        locations = matchValue_1.fields[0];
        storage = matchValue.fields[0];
        users = matchValue_2.fields[0];
    }
    switch (matchResult) {
        case 0:
            return createElement(StorageForm, {
                AccountSettings: accountSettings,
                BusinessUnits: businessUnits,
                CustomerConfiguration: configuration,
                Dispatch: dispatch,
                Dto: state_1.Dto,
                FormState: state_1.FormState,
                Header: patternInput_1[0]("storage.storage_edit"),
                Locations: locations,
                OnBack: () => {
                    RouterModule_nav(ofArray(["storages"]), 1, 1);
                },
                OnSave: () => {
                    dispatch(new Msg(7, []));
                },
                Users: users,
            });
        default:
            return createElement(Skeleton, {
                Variant: "detail",
            });
    }
}

